import { Table, TableCell, TableFooter, TablePagination, TableRow } from "@mui/material";
import { useEffect, useState } from "react";
import { IGTableProps, TCellType, TOnPage, TOnSort, TRenderData, TSort } from "./GTableConsts";
import useGTableHeader, { restoreSort, saveSort } from "./GTableHeader";
import GTableFooter from "./GTableFooter";
import GTableBody from "./GTableBody";
import GWidgetHelpers from "../widgets/IGWidget";
import InfiniteScroll from "../scroll/InfiniteScroll";
import { appendClass } from "../GWidget";

export {restoreSort,saveSort};
export type { TOnSort, TSort, TCellType, TRenderData }

function GTablePager(props:{rowCount:number, rowsPerPage:number, page:number, onPage:TOnPage}){
    const {rowCount,rowsPerPage,page} = props;
    const onPage = (e:any,page:number) => props.onPage(page)
    return <TableFooter><TableRow>
        <TablePagination count={rowCount} rowsPerPageOptions={[rowsPerPage]} rowsPerPage={rowsPerPage} color="primary" page={page} onPageChange={onPage}/>
    </TableRow></TableFooter>
}

let g_tableId=0

export default function GTable<T>(props:IGTableProps<T>){
    const {rows:all,...tableProps} = props

    const [scrollX,setScrollX] = useState<boolean>(false)
    const [scrollY,setScrollY] = useState<boolean>(false)
    const [tableId,setTableId] = useState<number>(++g_tableId)

    const rowsPerPage = props.infiniteScroll ? 25 : props.rowsPerPage || 0
    const pageCount = props.rowsPerPage ? Math.ceil(all.length/rowsPerPage) : 1

    const value = props.value ? props.value : (row:T,col:string) => (row as any)[col] || "-"
    const filterRows = (sort: TSort) => {
        if (!props.disableSort) {
            const sortP = props.sorter ? props.sorter(sort[0], sort[1]) : 
                (l:T,r:T) => ((value(l, sort[0]) < value(r, sort[0]) ? -1 : 1)*sort[1])
            all.sort(sortP)
        }
        return all.slice(index, count)
    }
    
    // sort
    const {header,sort} = useGTableHeader(props)

    // pagination
    const [page,setPage] = useState<number>(props.page||0);
    const [index,setIndex] = useState<number>(props.page ? props.page*rowsPerPage : 0)
    const [count,setCount] = useState<number>(rowsPerPage || all.length)

    // filtered row
    const [rows,setRows] = useState<T[]>(filterRows(sort))

    const onPage = (page:number) => {
        setPage(page)
        setIndex(page*rowsPerPage)
        props.onPage?.(page)
    }

    const onMore = () => {
        props.onScroll?.(props.rows.length)
        setCount((count:number) => Math.min(all.length, count+rowsPerPage))
    }

    useEffect(() => { setRows(filterRows(sort)) }, [page,count,sort])

    useEffect(() => {
        const minCount = rowsPerPage || props.rows.length
        const _count = Math.min(minCount, props.rows.length)
        setTableId(++g_tableId)
        setIndex(0)
        setCount(_count)
        setRows(filterRows(sort))
    }, [props.rows])
    
    const scroller = props.infiniteScroll && props.rows.length ? <TableFooter><TableRow><TableCell colSpan={props.cols.length}><InfiniteScroll onScroll={onMore} root={`.table_${tableId}`}/></TableCell></TableRow></TableFooter> : null
    const footer = props.footers ? <GTableFooter {...props} value={props.footerValue || value} bodyCell={props.footerCell||props.bodyCell} bodyRowProps={props.footerRowProps} bodyCellProps={props.footerCellProps||props.bodyCellProps}/> : null
    const pager = pageCount>1 ? <GTablePager rowCount={all.length} rowsPerPage={rowsPerPage} page={page} onPage={onPage}/> : null
    const onScroll = (e:any) => {
        setScrollX(e.target?.scrollLeft>0)
        setScrollY(e.target?.scrollTop>0)
    }
    const onContextMenu = (e:any) => props.onContextMenu?.(e)
    const classNames = {...props.classNames, scrollX, scrollY}
    return <div className={appendClass("tableContainer", `table_${tableId}`)} onScroll={onScroll} onContextMenu={onContextMenu}><Table className={GWidgetHelpers.toString(classNames)}>
        {header}
        <GTableBody {...tableProps} rows={rows} value={value}/>
        {scroller}
        {footer}
        {pager}
    </Table>{props.children}</div>
}